﻿'use strict';

/**
 * @ngdoc directive
 * @name ntmApp.directive:toggleButton
 * @description
 * # toggleButton
 */
angular.module('ntmApp')
  .directive('toggleButton', ['$rootScope', function ($rootScope) {
      return {
          restrict: 'A',
          require: 'ngModel',
          scope: {
              ngModel: '='
          },
          link: function (scope, element, attr) {
              $(element).bootstrapToggle({
                  on: attr.onText || '',
                  off: attr.offText || ''
              });

              $(element).prop('checked', scope.ngModel ? true : false)
                        .change();

              $(element).change(function () {
                  scope.ngModel = $(this).prop('checked');

                  if (!$rootScope.$$phase && !scope.$$phase) {
                      scope.$apply();
                  }
              });

              scope.$watch('ngModel', function (value) {
                  $(element).prop('checked', value ? true : false)
                            .change();
              });
          }
      };
  }]);